import React from 'react';
import { Button } from '@material-ui/core';

export default function AddressLink({ href, className, ...other }) {
    return (
        href && (<Button className={className} href={'http://maps.google.com/?q=' + href} target='_blank' color='primary' {...other} style={{ whiteSpace: 'normal' }}></Button>)
    )
}